import GrantContainer from "./containers/GrantContainer";
import "./styles.scss";
export default GrantContainer;
